import React, { useEffect, useState } from 'react'
import { Form, Field, FormElement } from '@progress/kendo-react-form';
import { Grid } from "@mui/material";
import Stack from "@mui/material/Stack";
import { useNavigate } from "react-router-dom";
import UiInput from '../../../../_uiComponents/telerikComponents/UiInput'

import UiDropDownList from '../../../../_uiComponents/telerikComponents/UiDropDownList';
import {
    UiButton,
} from "../../../../_uiComponents/common/form/UiButton";
import { MainLeftTitle } from "../../../../_uiComponents/WrapperComponents";
import { UiBackButton } from '../../../../_uiComponents/common/form/UiButton';
import { useDispatch } from 'react-redux';
import { participantGetApplicationRequest, participantGetAreasRequest, participantGetDealersRequest, participantGetRolesRequest, participantSaveNewParticipantRequest } from '../../../../../_redux/_actions';
import { useSelector } from 'react-redux';
import { UiSwitch } from '../../../../_uiComponents/telerikComponents/UiSwitch';


export default function AddParticipants(props) {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { applications, areaList, jobRoleList, dealerList } = useSelector((state) => ({
        applications: state?.participantsManagement?.application,
        areaList: state?.participantsManagement?.areaList,
        jobRoleList: state?.participantsManagement?.jobRoleList,
        dealerList: state?.participantsManagement?.dealerList,
    }));

    const [applicationType, setApplicationType] = useState(1);
    const [isChecked, setIschecked] = useState(true);
    const [areaType, setAreaType] = useState(null);
    const [jobRoleType, setJobRoleType] = useState(null);
    const [dealerType, setDealerType] = useState(null);

    console.log(applicationType)

    useEffect(() => {
        dispatch(participantGetApplicationRequest());
    }, [dispatch]);

    useEffect(() => {
        dispatch(participantGetAreasRequest({ applicationId: applicationType }));
        dispatch(participantGetDealersRequest({ applicationId: applicationType }));
        dispatch(participantGetRolesRequest({ applicationId: applicationType }));
    }, [applicationType, dispatch]);

    const emailRegex = new RegExp(/\S+@\S+\.\S+/);
    const firstNameValidator = value => value ? '' : 'First Name is required.';
    const lastNameValidator = value => value ? '' : 'Last Name is required.';
    const applicationsValidator = value => value ? '' : 'Application is required.';
    const jobRoleValidator = value => value ? '' : 'Job Role is required.';
    const dealerValidator = value => value ? '' : 'Dealer is required.';
    const areaValidator = value => value ? '' : 'Area is required.';
    const emailValidator = value => !value ? 'Email is required.' : emailRegex.test(value) ? '' : 'Email is not in a valid format.';

    const handleSubmit = dataItem => {
   
        const payload = {
            ApplicationId: applicationType,
            DealershipId: dealerType === null ? jobRoleList[0].id : dealerType,
            JobRoleId: jobRoleType === null ? dealerList[0].id : jobRoleType,
            Email: dataItem.email,
            FirstName: dataItem.firstName,
            LastName: dataItem.lastName,
            Active: isChecked
        }
       
        dispatch(participantSaveNewParticipantRequest(payload))
    }

    console.log('jobRoleType', jobRoleType);
    

    return (
        <>
            <MainLeftTitle title="Add Participants" />
            <Form onSubmit={handleSubmit}
                render={formRenderProps =>
                    <Grid container spacing={2}>
                        <div className="sba-input-areas-wr">

                            {applications.length > 0 && (
                                <Grid item xs={12} lg={6} sx={{ mt: 1 }}>

                                    <Field name={'applications'}
                                        component={UiDropDownList}
                                        labelClassName={'k-form-label'}
                                        data={applications.filter((app) => app.id !== 0).map((app) => ({
                                            value: app.id.toString(),
                                            label: app.name,
                                        }))}
                                        label={'Applications'}
                                        validator={applicationsValidator}
                                        value={applicationType}
                                        onChange={(e) => setApplicationType(e.value?.value)} />


                                    {/* <Field name={'applications'}
                                        component={UiDropDownList}
                                        labelClassName={'k-form-label'}
                                        data={applications.filter((app) => app.id !== 0).map((app) => ({
                                            value: app.id.toString(),
                                            label: app.name,
                                        }))}
                                        label={'Applications'}
                                        validator={applicationsValidator}
                                        value={applicationType}
                                        handleChange={setApplicationType} /> */}
                                </Grid>
                            )}
                            {jobRoleList.length > 0 &&
                                <Grid item xs={12} lg={6} sx={{ mt: 1 }}>
                                    <Field name={'jobRole'}
                                        component={UiDropDownList}
                                        labelClassName={'k-form-label'}
                                        data={jobRoleList.map((jobRole) => ({
                                            value: jobRole.id,
                                            label: jobRole.name,
                                        }))}
                                        label={'Job Role'}
                                        validator={jobRoleValidator}
                                        value={jobRoleType}
                                        onChange={(e) => setJobRoleType(e.value?.value)} />
                                </Grid>
                            }
                            {(jobRoleType !== null && jobRoleType !== 20) && dealerList.length > 0 && (
                                <Grid item xs={12} lg={6} sx={{ mt: 1 }}>
                                    <Field name={'dealer'}
                                        component={UiDropDownList}
                                        labelClassName={'k-form-label'}
                                        data={dealerList.map((dealer) => ({
                                            value: dealer.id.toString(),
                                            label: dealer.name,
                                        }))}
                                        label={'Dealer'}
                                        validator={dealerValidator}
                                        value={dealerType}
                                        onChange={(e) => setDealerType(e.value?.value)} />
                                </Grid>
                            )}

                            {(jobRoleType !== null && jobRoleType === 20) && areaList.length > 0 && (
                                <Grid item xs={12} lg={6} sx={{ mt: 1 }}>
                                    <Field name={'area'}
                                        component={UiDropDownList}
                                        labelClassName={'k-form-label'}
                                        data={areaList.map((area) => ({
                                            value: area.id.toString(),
                                            label: area.name,
                                        }))}
                                        label={'Area'}
                                        validator={areaValidator}
                                        value={areaType}
                                        onChange={(e) => setAreaType(e.value?.value)} />
                                </Grid>
                            )}

                            {/* {jobRoleList.length > 0 && (
                                <Grid item xs={12} lg={6} sx={{ mt: 1 }}>

                                <Field
                                    name="jobRole"
                                    component={(fieldRenderProps) => (
                                        <UiDropDownList
                                        {...fieldRenderProps} // Includes the validation and other Field props
                                        data={jobRoleList.map((jobRole) => ({
                                            value: jobRole.id,
                                            label: jobRole.name,
                                        }))}
                                        value={jobRoleType}
                                        label="Job Role"
                                        handleChange={(selectedValue) => setJobRoleType(selectedValue)}
                                        validator={jobRoleValidator}
                                        />
                                    )}
                                    validator={jobRoleValidator}
                                    />
                                </Grid>
                            )}

                            {(jobRoleType !== null && jobRoleType?.value !== 20) && dealerList.length > 0 && (
                                <Grid item xs={12} lg={6} sx={{ mt: 1 }}>

                                    <Field name={'dealer'}
                                        component={UiDropDownList}
                                        labelClassName={'k-form-label'}
                                        data={dealerList.map((dealer) => ({
                                            value: dealer.id.toString(),
                                            label: dealer.name,
                                        }))}
                                        label={'Dealer'}
                                        validator={dealerValidator}
                                        value={dealerType}
                                        handleChange={setDealerType} />

                                </Grid>
                            )}

                            {(jobRoleType !== null && jobRoleType?.value === 20) && areaList.length > 0 && (
                                <Grid item xs={12} lg={6} sx={{ mt: 1 }}>
                                    <Field name={'area'}
                                        component={UiDropDownList}
                                        labelClassName={'k-form-label'}
                                        data={areaList.map((area) => ({
                                            value: area.id.toString(),
                                            label: area.name,
                                        }))}
                                        label={'Area'}
                                        validator={areaValidator}
                                        value={areaType}
                                        handleChange={areaType} />

                                </Grid>
                            )} */}

                            <Grid item xs={12} lg={6} sx={{ mt: 2 }}>
                                <Field name={'email'}
                                    validator={emailValidator}
                                    component={UiInput}
                                    labelClassName={'k-form-label'}
                                    label={'Email'} />
                            </Grid>

                            <Grid item xs={12} lg={6} sx={{ mt: 2 }}>
                                <Field name={'firstName'}
                                    validator={firstNameValidator}
                                    component={UiInput}
                                    labelClassName={'k-form-label'}
                                    label={'First name'} />
                            </Grid>
                            <Grid item xs={12} lg={6} sx={{ mt: 2 }}>
                                <Field name={'lastName'}
                                    component={UiInput}
                                    validator={lastNameValidator}
                                    labelClassName={'k-form-label'}
                                    label={'Last name'} />
                            </Grid>

                            <Grid item xs={12} lg={6} sx={{ mt: 2 }}>
                                <Field name={'status'}
                                    component={UiSwitch}
                                    labelClassName={'k-form-label'}
                                    handleChange={setIschecked}
                                    isChecked={isChecked}
                                    label={'Status'} />
                            </Grid>

                            <Grid item xs={12}>
                                <Stack
                                    spacing={2}
                                    direction="row"
                                    justifyContent="space-between"
                                    sx={{ width: "100%", mt: 1.5 }}
                                >
                                    <UiBackButton size="small" onClick={() => navigate(-1)} />
                                    <div className="sbt-right-action-btn-wr">
                                        <UiButton
                                            name="Cancel"
                                            variant="outlined"
                                            size="small"
                                            onClick={formRenderProps.onFormReset}
                                        />
                                        <UiButton
                                            name="Add"
                                            variant="contained"
                                            size="small"
                                            onClick={formRenderProps.onSubmit}
                                            disabled={!formRenderProps.allowSubmit}
                                        />

                                    </div>
                                </Stack>
                            </Grid>
                        </div>
                    </Grid>
                }
            />

        </>
    );
}

